import { withAuth } from '../../auth';
import AssignmentReview from '../../AssignmentReview/AssignmentReview';

const AssignmentReviewWithAuth = withAuth(AssignmentReview);

export default AssignmentReviewWithAuth;
